import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4b46c34c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "load-more-tooltip-trigger" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down",
  style: {"font-weight":"bold"}
}, null, -1))

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'load-more-button',
  props: {
  hasMore: {
    type: Boolean,
    default: undefined
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  hidden: {
    type: Boolean,
    default: false
  },
  current: {
    type: Number,
    default: undefined
  },
  total: {
    type: Number,
    default: undefined
  },
  containerStyle: {
    type: [String, Object],
    default: () => ({})
  },
  buttonStyle: {
    type: [String, Object],
    default: () => ({})
  }
},
  emits: ['loadMore', 'click'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emit = __emit

const computedHasMore = computed(() => {
  if (props.hasMore !== undefined) {
    return props.hasMore
  }
  if (props.total !== undefined && props.current !== undefined) {
    return props.current < props.total
  }
  return true
})

const buttonText = computed(() => {
  let baseText = ''
  if (props.loading) {
    baseText = t('loadMore.loading')
  } else if (!computedHasMore.value) {
    baseText = t('loadMore.noMore')
  } else {
    baseText = t('loadMore.loadMore')
  }

  if (props.current !== undefined && props.total !== undefined && props.total > 0) {
    return `${baseText} ${t('loadMore.count', { current: props.current, total: props.total })}`
  }

  return baseText
})

const handleClick = () => {
  if (computedHasMore.value && !props.loading && !props.disabled) {
    emit('loadMore')
    emit('click')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (!__props.hidden)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "load-more-wrap",
        style: _normalizeStyle(__props.containerStyle)
      }, [
        _createVNode(_component_el_tooltip, {
          placement: "top",
          content: _unref(t)('loadMore.scrollToLoadTip'),
          disabled: !computedHasMore.value || __props.loading
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
              _createVNode(_component_el_button, {
                type: "text",
                style: _normalizeStyle([{"width":"100%"}, __props.buttonStyle]),
                size: "large",
                loading: __props.loading,
                disabled: !computedHasMore.value || __props.loading || __props.disabled,
                onClick: handleClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(buttonText.value) + " ", 1),
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["loading", "disabled", "style"])
            ])
          ]),
          _: 1
        }, 8, ["content", "disabled"])
      ], 4))
    : _createCommentVNode("", true)
}
}

})